/* global FilePond */

export function isAnyFileUploading() {
  if (typeof FilePond === 'undefined') return false;
  const ponds = document.querySelectorAll('.filepond--root');
  for (let i = 0; i < ponds.length; i += 1) {
    const pond = FilePond.find(ponds[i]);
    if (pond) {
      const files = pond.getFiles();
      for (let j = 0; j < files.length; j += 1) {
        const { status } = files[j];
        // LOADING = 7, PROCESSING = 3, PROCESSING_QUEUED = 9
        if (status === 7 || status === 3 || status === 9) {
          return true;
        }
      }
    }
  }
  return false;
}

export function updateSubmitButtonState($submitButton, $submitErrorMessage, translateFn) {
  if (isAnyFileUploading()) {
    $submitButton.attr('disabled', true);
    $submitButton.css('opacity', '0.5');
    $submitButton.css('cursor', 'not-allowed');
    $submitErrorMessage.removeClass('dn');
    $submitErrorMessage.text(translateFn('Please wait for file upload to complete before submitting.'));
    $submitErrorMessage.data('upload-error', true);
  } else {
    $submitButton.attr('disabled', false);
    $submitButton.css('opacity', '');
    $submitButton.css('cursor', '');
    if ($submitErrorMessage.data('upload-error')) {
      $submitErrorMessage.addClass('dn');
      $submitErrorMessage.text('');
      $submitErrorMessage.removeData('upload-error');
    }
  }
}
